import React from 'react'

const NumberPills = ({ value, onChange, options }) => (
  <div className="flex items-center min-w-[230px] max-w-[270px] rounded-full border border-gray-400 overflow-hidden bg-white shadow-sm">
    {options.map((n, idx) => (
      <button
        key={n}
        type="button"
        onClick={() => onChange(n)}
        className={`flex-1 h-9 text-xs sm:text-sm font-semibold ${
          value === n ? 'text-[#0b5bff]' : 'text-gray-900'
        } ${idx === 0 ? '' : 'border-l border-gray-300'}`}
        style={{ boxShadow: value === n ? 'inset 0 0 0 2px #0b5bff' : 'none' }}
      >
        {n}
      </button>
    ))}
  </div>
)

export default NumberPills
